import { Slider } from '@tunein/react-ui';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { player } from 'src/client/player';
import css from './scrubber.module.scss';

const SLIDER_MAX = 100;

export default function SeekSlider({
  disabled,
  className,
  sliderMax,
  elapsedPercent,
  onChangeCommitted,
  isInNowPlayingDialog,
  'data-testid': dataTestId,
}) {
  const [draftPercent, setDraftPercent] = useState(null);
  const currentPercent = Math.min(elapsedPercent, SLIDER_MAX);

  useEffect(() => {
    if (draftPercent === null) {
      return;
    }

    if (Math.abs(currentPercent - draftPercent) < 1) {
      setDraftPercent(null);
    }
  }, [currentPercent, draftPercent]);

  const getSliderValue = (value) => {
    return Array.isArray(value) ? value[0] : value;
  };

  const handleValueChange = (value) => {
    setDraftPercent(getSliderValue(value));
  };

  const handleValueCommitted = (value) => {
    const nextPercent = getSliderValue(value);

    setDraftPercent(nextPercent);
    onChangeCommitted((nextPercent / SLIDER_MAX) * player.getDuration());
  };

  return (
    <Slider
      data-testid={dataTestId ?? `scrubber-disabled-${disabled}`}
      className={clsx(css.slider, className, {
        [css.disabled]: disabled,
        [css.nowPlayingSlider]: isInNowPlayingDialog,
      })}
      disabled={disabled}
      value={draftPercent ?? currentPercent}
      max={sliderMax}
      controlClassName={clsx({ [css.disabledControl]: disabled })}
      trackClassName={clsx(css.sliderTrack, {
        [css.nowPlayingSliderTrack]: isInNowPlayingDialog,
      })}
      rangeClassName={clsx(css.sliderRange, {
        [css.nowPlayingSliderRange]: isInNowPlayingDialog,
      })}
      thumbClassName={clsx(css.sliderThumb, {
        [css.disabledThumb]: disabled,
        [css.nowPlayingSliderThumb]: isInNowPlayingDialog,
      })}
      onValueChange={handleValueChange}
      onValueCommitted={handleValueCommitted}
    />
  );
}

SeekSlider.propTypes = {
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  sliderMax: PropTypes.number.isRequired,
  elapsedPercent: PropTypes.number.isRequired,
  onChangeCommitted: PropTypes.func.isRequired,
  isInNowPlayingDialog: PropTypes.bool,
};
